import React, { useEffect, useState } from 'react';
import { Container, CssBaseline, Typography } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LicenseDashboardTabs from './components/LicenseDashboardTabs';
import LoginPage from './components/LoginPage';
import ValidateLicensePage from './components/ValidateLicensePage'
import { AuthProvider, useAuth } from './context/AuthContext';
import { swapDealerToken } from './api/licenseService';
import StripeReturnPage from './components/StripeReturnPage';

function AppContent() {
    const { dealerToken } = useAuth();
    const [apiKey, setApiKey] = useState(localStorage.getItem('apiKey') || '');

    useEffect(() => {
        const fetchApiKey = async () => {
            if (dealerToken && dealerToken !== "") {
                try {
                    const { key, isMaster } = await swapDealerToken(dealerToken);
                    setApiKey(key);
                    localStorage.setItem('apiKey', key);
                    localStorage.setItem('isMaster', isMaster);
                } catch (err) {
                    console.error('Token swap failed:', err);
                    setApiKey('');
                    localStorage.setItem('apiKey', '');
                    localStorage.setItem('isMaster', '');
                }
            }
        };

        fetchApiKey();
    }, [dealerToken]);

    return apiKey && apiKey !== '' ? (
        <Container maxWidth="lg">
            <Typography variant="h3" align="center" gutterBottom sx={{ marginTop: 5 }}>
                SuperKasse Lizenzverwaltung
            </Typography>
            <LicenseDashboardTabs />
        </Container>
    ) : (
        <LoginPage />
    );
}

function App() {
  return (
    <AuthProvider>
      <CssBaseline />
          <Router>
              <Routes>
                  <Route path="/license/view" element={<ValidateLicensePage />} />
                  <Route path="/stripe/return" element={<StripeReturnPage />} />
                  <Route path="/" element={<AppContent />} />
              </Routes>
          </Router>
      </AuthProvider>

  );
}

export default App;